import { HttpContextToken } from '@angular/common/http';

/**
 * Marks a request as a "does this entity exist" lookup driving a whole page/route
 * (typically set by a route resolver, via entityExistsResolver). When such a request
 * fails, HttpResponseInterceptor redirects to the 404 page (replacing history, so the
 * back button doesn't return to the same invalid URL) instead of surfacing the generic
 * error toast — set it only on lookups where "not found" should take over the page,
 * not on every request touching an id.
 */
export const ENTITY_LOOKUP_404 = new HttpContextToken<boolean>(() => false);
